import * as DialogPrimitive from "@radix-ui/react-dialog";
import { DialogContent } from "./DialogContent";
import { DialogHeader } from "./DialogHeader";
import { DialogTitle } from "./DialogTitle";
import { DialogDescription } from "./DialogDescription";
import { DialogFooter } from "./DialogFooter";
import { DialogChildren } from "./DialogChildren";
import { FC } from "react";
import { TDialogRootProps } from "./Dialog.config";


export const Dialog: FC<TDialogRootProps> = ({ title, description, children, footer, align, ...props }) => (
  <DialogPrimitive.Root {...props}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle align={align}>{ title }</DialogTitle>
        <DialogDescription align={align}>
          { description }
        </DialogDescription>
      </DialogHeader>
      <DialogChildren>
        { children }
      </DialogChildren>
      <DialogFooter {...footer} align={align} />
    </DialogContent>
  </DialogPrimitive.Root>
);
